import React, { Component } from "react";
import SchoolBadge from "../../SchoolBadge";
import "./style.css";
import "../../../../index.css";
class SchoolDetailTop extends Component {
  render() {
    const { data, sheetVisible } = this.props;
    return data === null ? (
      ""
    ) : (
      <div className="schoolDetailTop_box">
        <SchoolBadge
          className="schoolDetailTop_box_badge"
          src={data.schoolBadge}
          name={data.schoolName}
          placeholderFontSize={32}
        ></SchoolBadge>
        <div className="schoolDetailTop_box_name">{data.schoolName}</div>
        <div className="schoolDetailTop_box_location">{data.provinceCity}</div>
        <div className="schoolDetailTop_box_attribute">
          {data.schoolLevel === null ? (
            ""
          ) : (
            <div className="fl major_right_16">
              <img
                alt=""
                className="fl"
                src={require("../../../../images/school/level.png")}
              ></img>
              <div className="fl">{data.schoolLevel}</div>
            </div>
          )}
          {data.schoolTags.map((item, index) => {
            return (
              <div key={index} className="fl major_right_16">
                <img
                  alt=""
                  className="fl"
                  src={
                    item === "211"
                      ? require("../../../../images/school/211.png")
                      : item === "985"
                      ? require("../../../../images/school/211.png")
                      : require("../../../../images/school/dfr.png")
                  }
                ></img>
                <div className="fl">{item}</div>
              </div>
            );
          })}
          {data.schoolProperties === null ? (
            ""
          ) : (
            <div className="fl ">
              <img
                alt=""
                className="fl"
                src={require("../../../../images/school/property.png")}
              ></img>
              <div className="fl">{data.schoolProperties}</div>
            </div>
          )}
        </div>
        <div className="clear"></div>
        <div
          className={
            sheetVisible === true
              ? "schoolDetailTop_box_Sheet"
              : "schoolDetailTop_box_Sheet display_none"
          }
        ></div>
      </div>
    );
  }
}

export default SchoolDetailTop;



// WEBPACK FOOTER //
// ./src/components/School/SchoolDetail/SchoolDetailTop/index.js